import { useAuth } from "GlobalProvider";
import { Redirect } from "react-router";

interface Props {
  children: React.ReactNode;
}

export const LoginLayout = ({ children }: Props) => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      {children}
    </div>
  );
};
